import $ from "jquery";
import React from "react";
import { Button, Form } from "react-bootstrap";
import Header from "../../Components/Wholesaler/layout/header";
import ProductsImage from "../../Assets/images/products.svg";
import OfferValueImage from "../../Assets/images/offer-value.svg";
import BlockImg from "../../Assets/images/Brandiq.gif";
//import LogoBig from "../../Assets/images/logo-big.png";
import Blockbg from "../../Assets/images/blockbg.png";

import Arrowsvg from "../../Assets/images/arrow.svg";
import Arrow from "../../Assets/images/arrow.gif";
import FileIcon from "../../Assets/images/file-icon.png";
import CalenderSvgImage from "../../Assets/images/calender.svg";
import CalenderSvgRedImage from "../../Assets/images/calenderRed.svg";
import { Link } from "react-router-dom";
import ls from "local-storage";
import * as CONFIG from "../../Components/_config";
import axios from "axios";
import RV from "simple-react-validator";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Redirect } from "react-router";
import FooterStrict from "../Dashboard/FooterStrict";
import CouponSummary from "./CouponSummary";
import CouponPreview from "./CouponPreview";
import { CalenderDateFormatter, DateFormatter } from "../../Components/Helper";
import { renderTooltip } from "../../Components/Helper";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Info from "../../Assets/images/info.png";

class EditCoupon extends React.Component {
  constructor(props) {
    super(props);
    this.validator = new RV();
    this.validator.visibleFields = [];
    toast.configure();

    this.state = {
      formControls: {},
      upcArr: [],
      error: []
    };

    this.handleUpcChange = this.handleUpcChange.bind(this);
  }

  async componentDidMount() {
    $(".wizard li").click(function () {
      $(this).removeClass("completed");
      $(this).prevAll().addClass("completed");
      $(this).nextAll().removeClass("completed");
      $(".wizard li").removeClass("active");
      $(this).addClass("active");
    });
    $(".Offer_Type").on("click", function () {
      $(".Offer_Type").removeClass("Selected");
      $(this).addClass("Selected");
    });
    $(".Search_Box").on("click", function () {
      $(".Search_Box input").css("display", "block");
    });

    $(document).mouseup(function (e) {
      if ($(e.target).closest(".Search_Box input").length === 0) {
        $(".Search_Box input").css("display", "none");
      }
    });

    var coupon_guid = this.props.match.params.coupon_guid;

    var config = {
      method: "get",
      url: CONFIG.API_URL + `coupon/${coupon_guid}`,
      headers: CONFIG.config_head.headers
    };

    axios(config)
      .then((response) => {
        //console.log('response', response);

        if (response.data.Message.coupon_type_name === "PercentOff") {
          this.setState({ offer_type: 2, disabled: "none" });
        } else {
          this.setState({ offer_type: 1, dis: "none" });
        }
        this.setState({
          couponsDetails: response.data.Message,
          UpcList: response.data.Message.upc,
          selectedFile: response.data.Message.image_1,

          formControls: {
            title: response.data.Message.coupon_title,
            description: response.data.Message.coupon_description,
            reward_amount: response.data.Message.reward_amount
          }
        });

        //this.getCouponSearch();
        //this.selectRetailer();
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 502) {
            toast.error("Bad Request!");
          } else if (error.response.status === 400) {
            toast.error(error.response.data.Message);
          } else if (error.response.status === 403) {
            toast.error(error.response.data.Message);
            ls.clear("token");
            ls.clear("brands");
            window.location.href = "/login";
          } else {
            console.log(error);
          }
        }
      });
  }

  changeHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({
      formControls: {
        ...this.state.formControls,
        [name]: value
      }
    });
  };

  //   //const value = e.target.value;
  //   const value1 = e.target.value.replace(/-/g, "/");

  //   const iso_camp_start_date = new Date(e.target.value);
  //   const iso_camp_start_date1 = new Date(value1);

  //   const setstartdate = this.handleSeconDdate(iso_camp_start_date1);

  //   this.state.camp_wholesaler_start_date[key] = setstartdate;

  //   this.setState({
  //     wholesaler_start_date: this.state.camp_wholesaler_start_date
  //   });

  //   this.state.camp_iso_wholesaler_start_date[key] =
  //     iso_camp_start_date.toISOString();

  //   this.setState({
  //     iso_wholesaler_start_date: this.state.camp_iso_wholesaler_start_date
  //   });
  // };

  // onchangesetRetailerstartdate = async (e, key) => {
  //   //const value = e.target.value;
  //   const value1 = e.target.value.replace(/-/g, "/");

  //   // const iso_camp_start_date = new Date(e.target.value);
  //   //const iso_camp_start_date1 = new Date(value1);

  //   this.state.camp_retailer_start_date[key] = this.handleSeconDdate(
  //     new Date(value1)
  //   );

  //   this.setState({ retailer_start_date: this.state.camp_retailer_start_date });

  //   this.state.camp_iso_retailer_start_date[key] = new Date(
  //     value1
  //   ).toISOString();

  //   this.setState({
  //     iso_retailer_start_date: this.state.camp_iso_retailer_start_date
  //   });
  // };

  onFileChange = (event) => {
    let files = event.target.files;
    let images = event.target.files[0];

    if (!images.name.match(/\.(jpg|jpeg|png|gif|PNG|GIF|JPG)$/)) {
      toast.error("Please Select a Valid Image!");
      return false;
    }

    for (var i = 0; i < files.length; i++) {
      let file = files[i];
      let reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = () => {
        this.setState({ selectedFile: reader.result });
      };
    }
  };

  handleUpcChange(event) {
    var upcString = event.target.value;
    const upcArr = upcString.split(",");
    this.setState({ upcArr: upcArr, upcArrlength: upcArr.length });
  }

  checkValidation(upcArr) {
    if (upcArr.length > 0) {
      for (var i = 0; i < upcArr.length; i++) {
        if (isNaN(parseInt(upcArr[i]))) {
          this.state.error.push("error");
          return true;
        }
      }
      this.setState({ upcArrlength: upcArr.length, upcArr: upcArr, error: [] });
      return false;
    }
  }

  changeTab = async (e, key) => {
    var upc_guid_arr = [];

    if (this.state.upcArr.length > 0) {
      var string = this.state.upcArr.toString();
      var lastChar = string.slice(-1);

      if (lastChar === ",") {
        var afterString = string.slice(0, -1);
        var upcArray = afterString.split(",");
      } else {
        var upcArray = this.state.upcArr;
      }
      // console.log('string',afterString)

      const validationErr = this.checkValidation(upcArray);

      if (validationErr) {
        if (this.state.error.includes("error")) {
          toast.error(
            "Invalid UPCs entered - only integer and comma allowed no spaces",
            { theme: "colored" }
          );
          return false;
        }
      } else {
        upc_guid_arr = upcArray;
      }
    } else {
      this.state.couponsDetails.upc.map((val, idx) =>
        upc_guid_arr.push(val.upc11)
      );
    }

    //console.log(this.state.upcArr); return;

    var coupon_guid = this.props.match.params.coupon_guid;

    var data = JSON.stringify({
      upc: upc_guid_arr
    });

    var config = {
      method: "put",
      url: CONFIG.API_URL + `coupon/products/${coupon_guid}`,
      headers: CONFIG.config_head.headers,
      data: data
    };

    axios(config)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data.Message);
          $("#nav-step-" + key + "-tab").trigger("click");
        }
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 502) {
            toast.error("Bad Request!");
          } else if (error.response.status === 400) {
            toast.error(error.response.data.Message);
          } else if (error.response.status === 403) {
            toast.error(error.response.data.Message);
          } else {
            toast.error(error.response.data.Message);
          }
        }
      });
  };

  changeSecondTab = async (e, key) => {
    // var z= /^\d*$/;
    var z = new RegExp(/^\d*\.?\d*$/);
    if (
      !z.test($("#reward_amount").val()) ||
      $("#reward_amount").val().trim().length <= 0
    ) {
      toast.error("Please Fill Offer Value, accept only numeric values", {
        theme: "colored"
      });
      return false;
    } else if ($("#title").val().length <= 0) {
      toast.error("Please Fill Title Field", { theme: "colored" });
      return false;
    } else if ($("#description").val().trim().length <= 0) {
      toast.error("Please Fill  Description field", { theme: "colored" });
      return false;
    } else if (
      $("#min_purchase_amount").val().trim().length <= 0 ||
      !z.test($("#min_purchase_amount").val())
    ) {
      toast.error(
        "Please Fill Minimum Purchase Offer, accept only numeric values",
        { theme: "colored" }
      );
      return false;
    } else if ($("#min_purchase_amount").val() > 10) {
      toast.error(
        "Minimum Purchase Quantity should not have value greater than 10,",
        { theme: "colored" }
      );
      return false;
    } else if (
      $("input[type='date'][name='start_date']").val().length > 0 &&
      $("input[type='date'][name='end_date']").val().length > 0
    ) {
      var brand_guid = ls.get("brands") ? ls.get("brands")[0].guid : "";

      var data = JSON.stringify({
        title: this.state.formControls.title
          ? this.state.formControls.title
          : this.state.couponsDetails.title,

        description: this.state.formControls.description,
        offer_gs1: "",
        reward_amount: this.state.formControls.reward_amount
          ? parseFloat(this.state.formControls.reward_amount)
          : this.state.couponsDetails.reward_amount, //this.state.formControls.reward_amount

        coupon_code: this.state.formControls.coupon_code
          ? this.state.formControls.coupon_code
          : this.state.couponsDetails.coupon_code, //this.state.formControls.reward_amount

        min_purchase_amount: 1, // this.state.min_purchase_amount?this.state.min_purchase_amount:0,
        manufactuer_id: 0,
        coupon_category: 2,
        start_date: this.state.couponsDetails.coupon_start_date
          ? this.state.couponsDetails.coupon_start_date
          : "",
        end_date: this.state.couponsDetails.coupon_end_date
          ? this.state.couponsDetails.coupon_end_date
          : "",
        shutoff_date: this.state.couponsDetails.coupon_shutoff_date
          ? this.state.couponsDetails.coupon_shutoff_date
          : "",
        clip_limit: 0,
        redeem_limit: 0,
        clip_limit_amount: 0,
        is_flex: this.state.is_flex
          ? parseInt(this.state.is_flex)
          : this.state.couponsDetails.is_flex,
        coupon_target_type_id: this.state.couponsDetails
          ? this.state.couponsDetails.coupon_target_type_id
          : 2,
        redeem_limit_amount: 0,
        coupon_type: this.state.offer_type,
        reward_quantity: 0,
        min_quantity: this.state.formControls.min_purchase_amount
        ? parseInt(this.state.formControls.min_purchase_amount)
        : parseInt(this.state.couponsDetails.min_quantity),
        is_discount_percentage: this.state.offer_type === 1 ? 0 : 1,
        max_reward_limit: 0,
        limit_per_customer: 0,
        addtional_details: this.state.formControls.addtional_details
          ? this.state.formControls.addtional_details
          : this.state.couponsDetails.addtional_details,
        disclaimer: this.state.formControls.disclaimer
          ? this.state.formControls.disclaimer
          : this.state.couponsDetails.disclaimer,

        image_1: this.state.selectedFile,
        image_1_thumbnail: "string",
        media_url: "string",
        brand_guid: brand_guid,

        coupon_condition: {
          per_customer_limit: 1,
          per_transaction_limit: this.state.formControls.coupon_limit
            ? this.state.formControls.coupon_limit
            : this.state.couponsDetails.coupon_condition.per_transaction_limit
        }
      });
      var coupon_guid = this.props.match.params.coupon_guid;

      var config = {
        method: "put",
        url: CONFIG.API_URL + `coupon/${coupon_guid}`,
        headers: CONFIG.config_head.headers,
        data: data
      };

      axios(config)
        .then((response) => {
          if (response.status === 200) {
            toast.success("Updated Sucessfully");
            //ls.set('couponresponse',response.data.Message)
            $("#nav-step-" + key + "-tab").trigger("click");
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 502) {
              toast.error("Bad Request!");
            } else if (error.response.status === 400) {
              toast.error(error.response.data.Message);
            } else if (error.response.status === 403) {
              toast.error(error.response.data.Message);
              ls.clear("token");
              ls.clear("brands");
              window.location.href = "/login";
            } else {
              toast.error(error.response.data.Message);
            }
          }
        });
    } else {
      toast.error("Please Select Date", { theme: "colored" });
      return false;
    }
  };

  changeThirdTab = async (e, key) => {
    // this.setState({signup:true})
    $("#nav-step-" + key + "-tab").trigger("click");
  };

  changeRetailerFourthTab = async (e, key) => {
    //   var dateformat = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;
    $("#nav-step-" + key + "-tab").trigger("click");
  };

  changePrevTab = async (e, key) => {
    $("#nav-step-" + key + "-tab").trigger("click");
  };

  render() {
    const isLogged = ls.get("token");

    if (!isLogged) {
      return <Redirect to="/login" />;
    }

    return (
      <>
        <Header location={`editCoupon`} />

        <section className="ContentBlock pt-24 pb-24 Main_Block">
          <div className="Tab_Header">
            <div className="container-fluid">
              <div className="row ">
                <div className="col-12">
                  <ul className="nav nav-tabs wizard pb-70">
                    <li className="active">
                      <button
                        className="nav-link "
                        id="nav-step-1-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-step-1"
                        type="button"
                        role="tab"
                        aria-controls="step-1"
                        aria-selected="true"
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21 2.992V21.008C20.9979 21.2706 20.8926 21.5219 20.7068 21.7075C20.521 21.8931 20.2696 21.9982 20.007 22H3.993C3.72981 22 3.47739 21.8955 3.2912 21.7095C3.105 21.5235 3.00027 21.2712 3 21.008V2.992C3.00209 2.72938 3.10742 2.47813 3.29322 2.29251C3.47902 2.1069 3.73038 2.00183 3.993 2H20.007C20.555 2 21 2.444 21 2.992ZM19 4H5V20H19V4ZM11.293 13.121L15.536 8.879L16.95 10.293L11.293 15.95L7.403 12.06L8.818 10.646L11.293 13.121Z"
                            fill="current"
                          />
                        </svg>
                        Select Products
                      </button>
                    </li>
                    <li>
                      <button
                        className="nav-link"
                        id="nav-step-2-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-step-2"
                        type="button"
                        role="tab"
                        aria-controls="nav-step-2"
                        aria-selected="false"
                      >
                        <svg
                          width="19"
                          height="18"
                          viewBox="0 0 19 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.625 15.75C12.9288 15.75 12.2611 15.4734 11.7688 14.9812C11.2766 14.4889 11 13.8212 11 13.125C11 12.4288 11.2766 11.7611 11.7688 11.2688C12.2611 10.7766 12.9288 10.5 13.625 10.5C14.3212 10.5 14.9889 10.7766 15.4812 11.2688C15.9734 11.7611 16.25 12.4288 16.25 13.125C16.25 13.8212 15.9734 14.4889 15.4812 14.9812C14.9889 15.4734 14.3212 15.75 13.625 15.75ZM13.625 14.25C13.9234 14.25 14.2095 14.1315 14.4205 13.9205C14.6315 13.7095 14.75 13.4234 14.75 13.125C14.75 12.8266 14.6315 12.5405 14.4205 12.3295C14.2095 12.1185 13.9234 12 13.625 12C13.3266 12 13.0405 12.1185 12.8295 12.3295C12.6185 12.5405 12.5 12.8266 12.5 13.125C12.5 13.4234 12.6185 13.7095 12.8295 13.9205C13.0405 14.1315 13.3266 14.25 13.625 14.25ZM5.375 7.5C5.03028 7.5 4.68894 7.4321 4.37046 7.30018C4.05198 7.16827 3.7626 6.97491 3.51884 6.73116C3.27509 6.4874 3.08173 6.19802 2.94982 5.87954C2.8179 5.56106 2.75 5.21972 2.75 4.875C2.75 4.53028 2.8179 4.18894 2.94982 3.87046C3.08173 3.55198 3.27509 3.2626 3.51884 3.01884C3.7626 2.77509 4.05198 2.58173 4.37046 2.44982C4.68894 2.3179 5.03028 2.25 5.375 2.25C6.07119 2.25 6.73887 2.52656 7.23116 3.01884C7.72344 3.51113 8 4.17881 8 4.875C8 5.57119 7.72344 6.23887 7.23116 6.73116C6.73887 7.22344 6.07119 7.5 5.375 7.5ZM5.375 6C5.67337 6 5.95952 5.88147 6.1705 5.6705C6.38147 5.45952 6.5 5.17337 6.5 4.875C6.5 4.57663 6.38147 4.29048 6.1705 4.0795C5.95952 3.86853 5.67337 3.75 5.375 3.75C5.07663 3.75 4.79048 3.86853 4.5795 4.0795C4.36853 4.29048 4.25 4.57663 4.25 4.875C4.25 5.17337 4.36853 5.45952 4.5795 5.6705C4.79048 5.88147 5.07663 6 5.375 6ZM14.8032 2.63625L15.8638 3.69675L4.1975 15.3638L3.137 14.3032L14.8025 2.63625H14.8032Z"
                            fill="current"
                          />
                        </svg>
                        Build Offer
                      </button>
                    </li>
                    <li>
                      <button
                        className="nav-link"
                        id="nav-step-3-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-step-3"
                        type="button"
                        role="tab"
                        aria-controls="nav-step-3"
                        aria-selected="false"
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM11.003 16L6.76 11.757L8.174 10.343L11.003 13.172L16.659 7.515L18.074 8.929L11.003 16Z"
                            fill="current"
                          />
                        </svg>
                        Preview
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <form method="post" className="Offer_Form">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div
                    className="tab-content Wizard_Content mb-30"
                    id="nav-tabContent"
                  >
                    <div
                      className="tab-pane fade show active"
                      id="nav-step-1"
                      role="tabpanel"
                      aria-labelledby="nav-step-1-tab"
                    >
                      <div className="row  g-3">
                        <div className="col-xxl-9 col-xl-8 col-12">
                          <div className="Steps_Header d-flex align-items-center justify-content-between">
                            <h5 className="">Edit Coupon</h5>
                            <div className="Search_Box">
                              <input
                                type="text"
                                className="form-control Search_Toggle"
                                placeholder="Search"
                                aria-label="Search"
                                aria-describedby="search-addon"
                              />
                              <span className="Input_Icon">
                                <svg
                                  width="17"
                                  height="18"
                                  viewBox="0 0 17 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.7 14.9C11.4003 14.9 14.4 11.9003 14.4 8.2C14.4 4.49969 11.4003 1.5 7.7 1.5C3.99969 1.5 1 4.49969 1 8.2C1 11.9003 3.99969 14.9 7.7 14.9Z"
                                    stroke="white"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="3.3333"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M16.0004 16.5L12.4004 12.9"
                                    stroke="white"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="3.3333"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </span>
                            </div>
                          </div>
                          <div className="table-responsive Create_Coupons_Table">
                            {this.state.UpcList ? (
                              <>
                                {
                                  <div className="Common_Block_Body pt-17 pb-17 pr-14 pl-14 Build_Offer_Block">
                                    <h5 className="Title">
                                      Enter UPCs
                                      <OverlayTrigger
                                        placement="top"
                                        delay={{ show: 250, hide: 400 }}
                                        overlay={renderTooltip(
                                          "Only integer allowed, No spaces and special charcters like `@`,`#`,etc... not allowed "
                                        )}
                                      >
                                        <img
                                          src={Info}
                                          className="img-fluid"
                                          alt="Edit"
                                          style={{
                                            padding: "1px",
                                            width: "31px",
                                            height: "31px",
                                            cursor: "pointer"
                                          }}
                                        />
                                      </OverlayTrigger>
                                    </h5>

                                    <div className="row">
                                      <div className="col-lg-6 col-md-12 col-12">
                                        <textarea
                                          type="text"
                                          rows="10"
                                          onChange={this.handleUpcChange.bind(
                                            this
                                          )}
                                          className="upctextarea"
                                          defaultValue={
                                            this.state.UpcList
                                              ? this.state.UpcList.map(
                                                  (upc) => {
                                                    return upc.upc11;
                                                  }
                                                )
                                              : ""
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                }

                                <table className="table mb-0">
                                  <tfoot>
                                    <tr className="Bottom_Block">
                                      <td className="" colSpan="3">
                                        <div className="d-flex align-items-center justify-content-end">
                                          <div className="TableButton">
                                            <Button
                                              onClick={(e) =>
                                                this.changeTab(e, 2)
                                              }
                                            >
                                              Save & Next{" "}
                                              <i className="fas fa-arrow-right ml-10"></i>{" "}
                                            </Button>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>

                        <div className="col-xxl-3 col-xl-4 col-12">
                          <CouponSummary
                            upcArrlength={
                              this.state.UpcList
                                ? this.state.UpcList.length
                                : ""
                            }
                            reward_amount={
                              this.state.formControls.reward_amount
                            }
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      className="tab-pane fade"
                      id="nav-step-2"
                      role="tabpanel"
                      aria-labelledby="nav-step-2-tab"
                    >
                      <div className="row  g-3">
                        <div className="col-xxl-9 col-xl-8 col-12">
                          <div className="Steps_Header_Gray ">
                            <h5 className="">Edit Coupon</h5>
                          </div>

                          <div className="Common_Block">
                            <div className="Common_Block_Header d-flex align-items-center justify-content-between rounded-0">
                              <h5 className="">Offer Details</h5>
                            </div>
                            <div className="Common_Block_Body pt-17 pb-17 pr-14 pl-14 Build_Offer_Block">
                              <h5 className="Title">Offer Type</h5>

                              <div className="row">
                                <div className="col-lg-3 col-md-6 col-12">
                                  <div
                                    className={`Offer_Type ${
                                      this.state.offer_type === 1
                                        ? `Selected`
                                        : ` `
                                    }`}
                                    onClick={(e) =>
                                      this.onchangeOffertype(e, 1)
                                    }
                                    style={{
                                      pointerEvents: this.state.disabled
                                    }}
                                  >
                                    <svg
                                      width="75"
                                      height="76"
                                      viewBox="0 0 75 76"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <circle
                                        cx="37.125"
                                        cy="37.875"
                                        r="25"
                                        fill="current"
                                        className="DarkGray"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M15.2626 7.74333C21.3859 3.19119 28.9472 0.5 37.125 0.5C45.3028 0.5 52.8641 3.19119 58.9874 7.74333C59.8738 8.40233 60.0582 9.65516 59.3992 10.5416C58.7402 11.4281 57.4874 11.6124 56.6009 10.9534C51.1404 6.89402 44.4099 4.5 37.125 4.5C29.8401 4.5 23.1096 6.89403 17.6491 10.9535C16.7626 11.6124 15.5098 11.4281 14.8508 10.5416C14.1918 9.65516 14.3762 8.40233 15.2626 7.74333ZM64.3513 15.6001C65.2509 14.9592 66.4997 15.1688 67.1407 16.0684C71.5363 22.2377 74.125 29.8164 74.125 38C74.125 46.1836 71.5363 53.7623 67.1407 59.9316C66.4997 60.8311 65.2509 61.0408 64.3513 60.3999C63.4517 59.7589 63.242 58.5101 63.883 57.6105C67.8093 52.0998 70.125 45.3284 70.125 38C70.125 30.6716 67.8093 23.9002 63.883 18.3895C63.242 17.4899 63.4517 16.2411 64.3513 15.6001ZM9.89871 15.6001C10.7983 16.2411 11.008 17.4899 10.367 18.3895C6.4407 23.9002 4.125 30.6716 4.125 38C4.125 45.3284 6.4407 52.0998 10.367 57.6105C11.008 58.5101 10.7983 59.7589 9.89871 60.3999C8.99912 61.0408 7.75027 60.8312 7.10932 59.9316C2.71375 53.7623 0.125 46.1836 0.125 38C0.125 29.8164 2.71375 22.2377 7.10932 16.0684C7.75027 15.1689 8.99912 14.9592 9.89871 15.6001ZM14.8508 65.4584C15.5098 64.5719 16.7626 64.3876 17.6491 65.0466C23.1096 69.106 29.8401 71.5 37.125 71.5C44.4099 71.5 51.1404 69.106 56.6009 65.0465C57.4874 64.3876 58.7402 64.5719 59.3992 65.4584C60.0582 66.3448 59.8738 67.5977 58.9874 68.2567C52.8641 72.8088 45.3028 75.5 37.125 75.5C28.9472 75.5 21.3859 72.8088 15.2626 68.2567C14.3762 67.5977 14.1918 66.3448 14.8508 65.4584Z"
                                        fill="current"
                                        className="LightGray"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M15.2625 7.74333C21.3858 3.19119 28.947 0.5 37.1248 0.5C45.3027 0.5 52.8639 3.19119 58.9872 7.74333C59.8736 8.40233 60.058 9.65516 59.399 10.5416C58.74 11.4281 57.4872 11.6124 56.6007 10.9535C51.1402 6.89402 44.4097 4.5 37.1248 4.5C29.8399 4.5 23.1094 6.89403 17.6489 10.9535C16.7625 11.6125 15.5096 11.4281 14.8506 10.5416C14.1916 9.65516 14.376 8.40233 15.2625 7.74333ZM64.3511 15.6001C65.2507 14.9592 66.4995 15.1688 67.1405 16.0684C71.5361 22.2377 74.1248 29.8164 74.1248 38C74.1248 46.1836 71.5361 53.7623 67.1405 59.9316C66.4995 60.8311 65.2507 61.0408 64.3511 60.3999C63.4515 59.7589 63.2419 58.5101 63.8828 57.6105C67.8091 52.0998 70.1248 45.3284 70.1248 38C70.1248 30.6716 67.8091 23.9002 63.8828 18.3895C63.2419 17.4899 63.4515 16.2411 64.3511 15.6001Z"
                                        fill="current"
                                        className="LightGray"
                                      />
                                      <g clipPath="url(#clip0_588_3766)">
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M42.9727 28.5H36.4037C36.0318 28.5 35.7839 28.5 35.536 28.5652C35.2882 28.6303 35.0403 28.9561 34.8544 29.0864L26.0544 38.3385C24.7529 39.7068 24.7529 41.9873 26.1783 43.3555L32.9332 50.5227C34.2346 51.8909 36.4656 51.8909 37.767 50.5227L46.4431 41.4009C46.691 41.2054 46.8769 40.9448 46.9389 40.6841C46.9389 40.6841 47.0008 40.6841 47.0008 40.619V40.5538C47.0628 40.2932 47.0628 40.0326 47.0628 39.7068V32.8003C47.1248 29.9334 45.6994 28.5 42.9727 28.5ZM40.122 42.2479L40.3698 42.4433L40.4318 42.6388C40.8037 42.8994 40.8037 43.3555 40.4318 43.6161C40.1839 43.8768 39.7501 43.8768 39.5022 43.6161L39.3783 43.4858L39.1924 43.2904C38.5107 44.0071 37.6431 44.4632 37.0234 44.6586L36.1558 43.0949C36.8375 42.8994 37.6431 42.4433 38.3248 41.8569C38.8206 41.2054 39.0065 40.5538 38.6966 40.1629C38.2628 39.772 37.6431 39.9023 36.7135 40.4235C35.2262 41.1402 34.0487 41.4009 33.0572 40.3584C32.1276 39.4462 32.1276 38.0779 32.9332 36.7096L32.8713 36.6445C32.8093 36.6445 32.8093 36.6445 32.8093 36.6445L32.6853 36.3187C32.4375 36.0581 32.4375 35.602 32.6853 35.3414C32.9332 35.0807 33.367 35.0807 33.6149 35.3414L33.6769 35.4065L33.8628 35.602C34.5445 34.9504 35.1642 34.6246 35.66 34.4292L36.5276 35.8626C36.0938 36.0581 35.4121 36.3187 34.7304 37.0354C34.1107 37.7521 34.2346 38.2082 34.4825 38.5992C34.7304 38.8598 35.3501 38.7946 36.5896 38.1431C38.1389 37.296 39.1924 37.4263 40.122 38.4037C40.9896 39.3159 41.1135 40.7493 40.122 42.2479ZM43.7163 34.0382C43.2206 34.5595 42.3529 34.5595 41.7952 34.0382C41.8572 34.1034 42.0431 34.2989 41.7952 34.0382C41.5473 33.7776 41.6093 33.8428 41.7952 34.0382C41.2994 33.517 41.2994 32.6048 41.7952 32.0184C42.229 31.3669 43.1586 31.3669 43.7163 31.9533C44.2741 32.6048 44.2741 33.517 43.7163 34.0382Z"
                                          fill="current"
                                          className="White"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_588_3766">
                                          <rect
                                            width="22"
                                            height="23"
                                            fill="current"
                                            transform="translate(25.125 28.5)"
                                            className="White"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                    <span>$</span>
                                    <p>Amount Off</p>
                                  </div>
                                </div>

                                <div className="col-lg-3 col-md-6 col-12">
                                  <div
                                    className={`Offer_Type ${
                                      this.state.offer_type === 2
                                        ? `Selected`
                                        : ` `
                                    }`}
                                    onClick={(e) =>
                                      this.onchangeOffertype(e, 2)
                                    }
                                    style={{ pointerEvents: this.state.dis }}
                                  >
                                    <svg
                                      width="75"
                                      height="76"
                                      viewBox="0 0 75 76"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <circle
                                        cx="37.375"
                                        cy="37.875"
                                        r="25"
                                        fill="current"
                                        className="DarkGray"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M15.5126 7.74333C21.6359 3.19119 29.1972 0.5 37.375 0.5C45.5528 0.5 53.1141 3.19119 59.2374 7.74333C60.1238 8.40233 60.3082 9.65516 59.6492 10.5416C58.9902 11.4281 57.7374 11.6124 56.8509 10.9534C51.3904 6.89402 44.6599 4.5 37.375 4.5C30.0901 4.5 23.3596 6.89403 17.8991 10.9535C17.0126 11.6124 15.7598 11.4281 15.1008 10.5416C14.4418 9.65516 14.6262 8.40233 15.5126 7.74333ZM64.6013 15.6001C65.5009 14.9592 66.7497 15.1688 67.3907 16.0684C71.7863 22.2377 74.375 29.8164 74.375 38C74.375 46.1836 71.7863 53.7623 67.3907 59.9316C66.7497 60.8311 65.5009 61.0408 64.6013 60.3999C63.7017 59.7589 63.492 58.5101 64.133 57.6105C68.0593 52.0998 70.375 45.3284 70.375 38C70.375 30.6716 68.0593 23.9002 64.133 18.3895C63.492 17.4899 63.7017 16.2411 64.6013 15.6001ZM10.1487 15.6001C11.0483 16.2411 11.258 17.4899 10.617 18.3895C6.6907 23.9002 4.375 30.6716 4.375 38C4.375 45.3284 6.6907 52.0998 10.617 57.6105C11.258 58.5101 11.0483 59.7589 10.1487 60.3999C9.24912 61.0408 8.00027 60.8312 7.35932 59.9316C2.96375 53.7623 0.375 46.1836 0.375 38C0.375 29.8164 2.96375 22.2377 7.35932 16.0684C8.00027 15.1689 9.24912 14.9592 10.1487 15.6001ZM15.1008 65.4584C15.7598 64.5719 17.0126 64.3876 17.8991 65.0466C23.3596 69.106 30.0901 71.5 37.375 71.5C44.6599 71.5 51.3904 69.106 56.8509 65.0465C57.7374 64.3876 58.9902 64.5719 59.6492 65.4584C60.3082 66.3448 60.1238 67.5977 59.2374 68.2567C53.1141 72.8088 45.5528 75.5 37.375 75.5C29.1972 75.5 21.6359 72.8088 15.5126 68.2567C14.6262 67.5977 14.4418 66.3448 15.1008 65.4584Z"
                                        fill="current"
                                        className="LightGray"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M15.5126 7.74333C21.6359 3.19119 29.1972 0.5 37.375 0.5C45.5528 0.5 53.1141 3.19119 59.2374 7.74333C60.1238 8.40233 60.3082 9.65516 59.6492 10.5416C58.9902 11.4281 57.7374 11.6124 56.8509 10.9535C51.3904 6.89402 44.6599 4.5 37.375 4.5C30.0901 4.5 23.3596 6.89403 17.8991 10.9535C17.0126 11.6125 15.7598 11.4281 15.1008 10.5416C14.4418 9.65516 14.6262 8.40233 15.5126 7.74333ZM64.6013 15.6001C65.5009 14.9592 66.7497 15.1688 67.3907 16.0684C71.7863 22.2377 74.375 29.8164 74.375 38C74.375 46.1836 71.7863 53.7623 67.3907 59.9316C66.7497 60.8311 65.5009 61.0408 64.6013 60.3999C63.7017 59.7589 63.492 58.5101 64.133 57.6105C68.0593 52.0998 70.375 45.3284 70.375 38C70.375 30.6716 68.0593 23.9002 64.133 18.3895C63.492 17.4899 63.7017 16.2411 64.6013 15.6001ZM10.1487 15.6001C11.0483 16.2411 11.258 17.4899 10.617 18.3895C6.6907 23.9002 4.375 30.6716 4.375 38C4.375 45.3284 6.6907 52.0998 10.617 57.6105C11.258 58.5101 11.0483 59.7589 10.1487 60.3999C9.24913 61.0408 8.00027 60.8312 7.35932 59.9316C2.96375 53.7623 0.375 46.1836 0.375 38C0.375 29.8164 2.96375 22.2377 7.35932 16.0684C8.00027 15.1689 9.24912 14.9592 10.1487 15.6001ZM15.1008 65.4584C15.7598 64.5719 17.0126 64.3876 17.8991 65.0466C23.3596 69.106 30.0901 71.5 37.375 71.5C44.6599 71.5 51.3904 69.106 56.8509 65.0465C57.7374 64.3876 58.9902 64.5719 59.6492 65.4584C60.3082 66.3448 60.1238 67.5977 59.2374 68.2567C53.1141 72.8088 45.5528 75.5 37.375 75.5C29.1972 75.5 21.6359 72.8088 15.5126 68.2567C14.6262 67.5977 14.4418 66.3448 15.1008 65.4584Z"
                                        fill="current"
                                        className="LightGray"
                                      />
                                      <g clipPath="url(#clip0_588_3781)">
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M38.0322 52.2824L45.2942 40.7064C45.4664 40.3789 45.6386 40.0513 45.5042 39.7186L44.0654 33.1405C44.3647 32.8261 44.537 32.4986 44.941 32.1419C45.7943 31.0877 46.4905 30.0971 46.9996 29.2465C47.2317 28.7657 47.4115 28.3061 47.4866 27.8888C47.644 27.3737 47.4872 26.9856 47.2481 26.6952C47.1733 26.6609 47.1286 26.55 47.0238 26.5923C46.5305 26.2756 45.6478 26.5031 44.6826 27.2799C43.8296 27.8825 42.7745 28.8891 41.7641 30.0067L41.7266 30.2154C41.5471 30.2234 41.4947 30.2445 41.3452 30.1759L33.948 31.6158C33.6338 31.7428 33.372 31.8485 33.1474 32.1972L25.9378 43.752C25.3763 44.6238 25.6072 45.9495 26.5716 46.5274L35.2499 52.6322C36.2815 53.3765 37.4707 53.1541 38.0322 52.2824ZM43.7297 31.8572C43.6029 31.3924 43.2966 30.9357 42.878 30.6533C42.8556 30.5978 42.8556 30.5978 42.8032 30.619C43.6341 29.5094 44.5246 28.6982 45.2728 28.138C45.834 27.7178 46.3576 27.5063 46.5595 27.5538C46.5071 27.5749 46.5071 27.5749 46.4248 27.6727C46.3573 27.9579 46.2374 28.2643 46.0053 28.7451C45.6533 29.5323 44.9123 30.412 44.089 31.3896C44.0291 31.5428 43.8944 31.6617 43.7297 31.8572ZM41.9402 34.9664C40.9826 35.6112 40.1747 35.873 39.7561 35.5906C39.6813 35.5563 39.6813 35.5563 39.5318 35.4877C39.2179 35.163 39.1659 34.7326 39.2709 34.2387C39.2936 33.8425 39.4583 33.647 39.6381 33.1874C38.9949 33.2537 38.359 33.6395 37.9921 34.2392C37.3483 35.2087 37.624 36.6453 38.6555 37.3896C39.717 38.0573 40.9586 37.8138 41.6548 36.8231C42.0216 36.2235 42.0595 35.5632 41.9402 34.9664ZM40.6923 33.5355C40.4677 33.8842 40.3479 34.1906 40.3251 34.5868C40.2728 34.6079 40.1681 34.6503 40.1905 34.7057C40.3475 34.6422 40.7665 34.473 41.38 34.0317C41.1857 33.8522 41.0885 33.7625 40.9914 33.6727C40.8418 33.6041 40.8194 33.5487 40.6923 33.5355ZM31.0809 46.8344C30.5576 46.5943 30.2213 46.2142 29.9449 45.6808C29.7134 45.2584 29.6613 44.8279 29.8711 44.2917C30.1033 43.8109 30.425 43.552 30.9711 43.3959C31.39 43.2267 31.9956 43.3691 32.5414 43.6646C33.1394 43.939 33.6028 44.3323 33.8044 44.8314C33.9836 45.275 33.9833 45.7266 33.8559 46.165C33.6013 46.5904 33.302 46.9048 32.7783 47.1163C32.337 47.23 31.7837 47.0665 31.0809 46.8344ZM30.5739 44.5238C30.4317 44.7748 30.4165 45.0389 30.5285 45.3161C30.6705 45.5168 31.0667 45.7437 31.5077 46.0816C31.9562 46.2874 32.3077 46.4034 32.6218 46.2765C32.8537 46.2474 33.0407 46.1073 33.1306 45.8775C33.2205 45.6477 33.1833 45.4047 33.0937 45.1829C32.907 44.8714 32.6379 44.6576 32.1146 44.4175C31.6436 44.1562 31.3146 44.0956 31.0827 44.1248C30.7686 44.2517 30.6862 44.3494 30.5739 44.5238ZM37.504 48.1099L31.6912 40.2027L31.9908 39.4366L37.9084 47.3015L37.504 48.1099ZM36.9759 43.9373C36.4526 43.6972 36.1163 43.3171 35.8624 42.8392C35.6308 42.4167 35.5788 41.9863 35.8932 41.4078C36.073 40.9481 36.3424 40.7103 36.8885 40.5543C37.3074 40.3851 37.8682 40.4165 38.4588 40.823C39.0569 41.0974 39.5203 41.4907 39.6994 41.9343C39.8786 42.3779 39.9231 42.9404 39.7733 43.3234C39.5411 43.8042 39.2194 44.0631 38.7781 44.1769C38.2544 44.3884 37.7011 44.2249 36.9759 43.9373ZM36.4913 41.6822C36.3491 41.9331 36.3339 42.1972 36.4235 42.419C36.5655 42.6197 36.9841 42.9021 37.4027 43.1845C37.926 43.4246 38.2027 43.5063 38.5392 43.4349C38.7487 43.3503 38.9358 43.2102 39.0481 43.0359C39.1156 42.7506 39.1007 42.5631 38.9663 42.2304C38.8244 42.0297 38.5329 41.7605 38.0096 41.5204C37.5386 41.2591 37.1872 41.1431 36.9777 41.2277C36.6636 41.3546 36.5812 41.4523 36.4913 41.6822Z"
                                          fill="White"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_588_3781">
                                          <rect
                                            width="27.0511"
                                            height="21.1704"
                                            fill="white"
                                            transform="translate(21.9941 36.2507) rotate(-21.9948)"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>

                                    <span>%</span>
                                    <p>Percent Off</p>
                                  </div>
                                </div>

                                <div className="col-lg-3 col-md-6 col-12">
                                  <div
                                    className="Offer_Type"
                                    style={{
                                      pointerEvents: "none",
                                      opacity: "0.4"
                                    }}
                                  >
                                    <svg
                                      width="75"
                                      height="76"
                                      viewBox="0 0 75 76"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <circle
                                        cx="37.625"
                                        cy="37.875"
                                        r="25"
                                        fill="current"
                                        className="DarkGray"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M15.7626 7.74333C21.8859 3.19119 29.4472 0.5 37.625 0.5C45.8028 0.5 53.3641 3.19119 59.4874 7.74333C60.3738 8.40233 60.5582 9.65516 59.8992 10.5416C59.2402 11.4281 57.9874 11.6124 57.1009 10.9534C51.6404 6.89402 44.9099 4.5 37.625 4.5C30.3401 4.5 23.6096 6.89403 18.1491 10.9535C17.2626 11.6124 16.0098 11.4281 15.3508 10.5416C14.6918 9.65516 14.8762 8.40233 15.7626 7.74333ZM64.8513 15.6001C65.7509 14.9592 66.9997 15.1688 67.6407 16.0684C72.0363 22.2377 74.625 29.8164 74.625 38C74.625 46.1836 72.0363 53.7623 67.6407 59.9316C66.9997 60.8311 65.7509 61.0408 64.8513 60.3999C63.9517 59.7589 63.742 58.5101 64.383 57.6105C68.3093 52.0998 70.625 45.3284 70.625 38C70.625 30.6716 68.3093 23.9002 64.383 18.3895C63.742 17.4899 63.9517 16.2411 64.8513 15.6001ZM10.3987 15.6001C11.2983 16.2411 11.508 17.4899 10.867 18.3895C6.9407 23.9002 4.625 30.6716 4.625 38C4.625 45.3284 6.9407 52.0998 10.867 57.6105C11.508 58.5101 11.2983 59.7589 10.3987 60.3999C9.49912 61.0408 8.25027 60.8312 7.60932 59.9316C3.21375 53.7623 0.625 46.1836 0.625 38C0.625 29.8164 3.21375 22.2377 7.60932 16.0684C8.25027 15.1689 9.49912 14.9592 10.3987 15.6001ZM15.3508 65.4584C16.0098 64.5719 17.2626 64.3876 18.1491 65.0466C23.6096 69.106 30.3401 71.5 37.625 71.5C44.9099 71.5 51.6404 69.106 57.1009 65.0465C57.9874 64.3876 59.2402 64.5719 59.8992 65.4584C60.5582 66.3448 60.3738 67.5977 59.4874 68.2567C53.3641 72.8088 45.8028 75.5 37.625 75.5C29.4472 75.5 21.8859 72.8088 15.7626 68.2567C14.8762 67.5977 14.6918 66.3448 15.3508 65.4584Z"
                                        fill="current"
                                        className="LightGray"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M15.762 7.74333C21.8853 3.19119 29.4465 0.5 37.6243 0.5C45.8022 0.5 53.3634 3.19119 59.4867 7.74333C60.3731 8.40233 60.5575 9.65516 59.8985 10.5416C59.2395 11.4281 57.9867 11.6124 57.1002 10.9535C51.6397 6.89402 44.9092 4.5 37.6243 4.5C30.3394 4.5 23.609 6.89403 18.1484 10.9535C17.262 11.6125 16.0091 11.4281 15.3501 10.5416C14.6911 9.65516 14.8755 8.40233 15.762 7.74333Z"
                                        fill="current"
                                        className="LightGray"
                                      />
                                      <g clipPath="url(#clip0_588_3800)">
                                        <path
                                          d="M46.4508 31.8645C45.0738 29.9742 43.3489 28.9801 41.5854 29.071C39.4853 29.1803 37.7041 30.4317 36.6497 32.448C36.3864 32.949 36.1575 33.4802 35.9647 34.038C35.2431 34.4057 34.4072 34.7686 33.5128 35.0329C33.2322 34.984 32.9521 34.9699 32.6707 34.9855C32.5834 34.9896 32.4891 34.9989 32.3788 35.0132L27.3294 35.4235C24.9906 35.5437 23.2567 37.6631 23.4608 40.1423C23.6649 42.6215 25.7357 44.5416 28.062 44.4194L28.5629 44.4136L30.4168 50.0624C30.5593 50.6314 31.1594 51.0475 31.79 51.0154C31.7953 51.0137 31.7989 51.0155 31.8078 51.0156L33.1194 50.8683C33.2617 50.8526 33.3964 50.7985 33.5039 50.7178C33.5393 50.7008 33.5711 50.6821 33.5993 50.6615C34.31 50.1627 34.3695 50.0884 34.3991 50.0469C34.5967 49.7946 34.6163 49.4492 34.4426 49.1678L33.7697 48.0788C33.4736 47.6021 33.2588 47.088 33.1275 46.5505L32.5944 44.3533L33.0685 44.3472C33.213 44.3542 33.3342 44.354 33.4483 44.3503C33.7297 44.3347 34.0035 44.2893 34.2751 44.2125C35.2787 44.4399 36.2399 44.8065 37.0713 45.1993C37.282 45.5685 37.5103 45.9205 37.7579 46.2518C39.2494 48.2901 40.8774 49.2359 43.2446 49.1126C45.0045 49.0198 46.5554 47.8615 47.608 45.8399C48.6174 43.9051 49.0545 41.3904 48.8374 38.7575C48.6185 36.128 47.7713 33.679 46.4508 31.8645ZM37.3726 40.6986L40.1273 40.266L37.3191 40.1219L38.8991 39.814L37.2256 39.6076C37.2216 39.5796 37.2212 39.5535 37.219 39.5307L38.3192 39.3126L37.1834 39.0713C37.1811 39.0398 37.1789 39.0084 37.1766 38.9769L38.058 38.7927L37.1574 38.5386C37.1568 38.5037 37.1563 38.4688 37.154 38.4373L37.9449 38.2816L37.153 38.0254C37.1525 37.9905 37.1536 37.9521 37.1531 37.9172L37.9013 37.7662L37.1631 37.5282C37.1626 37.4932 37.1656 37.4601 37.1704 37.4235L40.7076 37.7881C40.3946 38.182 40.2222 38.7976 40.2812 39.4983C40.3137 39.8739 40.4064 40.2189 40.5429 40.5121L37.3862 40.7703C37.3822 40.7423 37.3747 40.7213 37.3726 40.6986ZM41.8048 40.9593C41.404 40.9804 40.9008 40.3701 40.8279 39.4633C40.7515 38.5548 41.1496 37.9002 41.5504 37.8791C41.9512 37.858 42.4544 38.4683 42.5273 39.3751C42.6037 40.2836 42.2056 40.9383 41.8048 40.9593ZM38.7092 33.8688C38.4176 34.0309 38.1205 34.1859 37.8197 34.3304C38.3794 33.8646 38.9844 33.4517 39.5914 33.044C40.3888 32.5062 41.2136 32.0036 42.0603 31.5379C42.3519 31.3759 42.649 31.2208 42.9499 31.0763C42.3902 31.5421 41.7851 31.955 41.1781 32.3627C40.3807 32.9005 39.5542 33.4066 38.7092 33.8688ZM38.4896 32.9235C38.8573 32.4919 39.3043 32.1171 39.7517 31.7685C40.1991 31.4199 40.6752 31.077 41.1918 30.8235C40.8241 31.2551 40.3771 31.6299 39.9297 31.9785C39.4769 32.3288 39.0009 32.6717 38.4896 32.9235ZM38.6027 44.3951L40.1026 45.2468L38.2862 43.5271L41.8835 45.2468L38.0966 42.6748L41.4793 43.7721L38.608 42.1978L41.9806 41.4886C42.0001 41.4854 42.0161 41.4804 42.0338 41.4719C42.7175 41.3061 43.1674 40.4217 43.0795 39.3472C43.0579 39.1026 43.0132 38.8682 42.944 38.6561L46.5501 37.8295L42.5636 37.9165C42.4689 37.7913 42.3639 37.687 42.2556 37.5984L46.6734 36.4662C46.6155 36.1775 46.5503 35.8852 46.4728 35.5997L42.1017 36.8721L46.294 34.9866C46.0595 34.2331 45.7557 33.4927 45.3738 32.774C45.3665 32.7617 45.3592 32.7494 45.3519 32.7371L41.0594 34.4817L45.1486 32.3889C44.9749 32.1075 44.7782 31.8362 44.5797 31.5683C46.173 33.0425 47.3732 35.7194 47.6314 38.8189C48.0302 43.6253 46.012 47.6556 43.1371 47.8074C41.3968 47.8969 39.7305 46.5423 38.6027 44.3951ZM30.948 49.9417C30.9461 49.9365 30.946 49.9277 30.9405 49.9207L29.1332 44.4034L29.274 44.4L29.7961 45.4224L29.7356 44.3919L29.9209 44.389L30.432 45.3886L30.3736 44.3808L30.5679 44.3781L31.0679 45.3549L31.0099 44.3733L31.1507 44.3698L31.8533 47.2708C31.9865 47.8135 32.1995 48.3311 32.4993 48.8096L33.2142 49.9672C33.2598 50.0376 33.2629 50.1214 33.2302 50.196C33.1939 50.2688 33.1251 50.3168 33.0433 50.328L31.7406 50.4754C31.4199 50.4888 31.0299 50.2814 30.948 49.9417ZM32.294 44.524C32.4836 45.1425 32.6413 45.7711 32.8007 46.3962C32.9107 46.8235 33.0295 47.2421 33.2069 47.651C33.3822 48.0373 33.6071 48.3962 33.8231 48.7637C34.0262 49.1031 34.3136 49.4716 34.1648 49.8781C34.1999 49.5015 33.9657 49.2245 33.7667 48.9218C33.5348 48.568 33.2994 48.2125 33.117 47.8314C32.7504 47.064 32.6088 46.2053 32.4498 45.3812C32.3919 45.0925 32.3394 44.8108 32.294 44.524ZM27.4292 38.5349C27.632 37.705 28.0109 36.9541 28.6381 36.3617C28.5056 36.4386 28.3732 36.5241 28.2499 36.6186C27.5911 37.1302 27.1576 37.8019 26.8735 38.5697C27.0764 37.7398 27.4552 36.9889 28.0825 36.3965C27.9499 36.4734 27.8176 36.5589 27.6942 36.6533C27.0354 37.165 26.6019 37.8367 26.3178 38.6045C26.5207 37.7746 26.8995 37.0237 27.5268 36.4313C27.3943 36.5081 27.2619 36.5937 27.1386 36.6881C26.4798 37.1998 26.0462 37.8715 25.7622 38.6393C25.9651 37.8094 26.3439 37.0585 26.9711 36.4661C26.8386 36.5429 26.7062 36.6285 26.5829 36.7229C25.9241 37.2346 25.4906 37.9063 25.2065 38.6741C25.4094 37.8442 25.7882 37.0933 26.4155 36.5009C26.283 36.5777 26.1506 36.6633 26.0273 36.7577C25.3684 37.2694 24.9349 37.9411 24.6509 38.7089C24.8537 37.879 25.2325 37.1281 25.8598 36.5357C26.0056 36.3962 26.1642 36.276 26.3247 36.1611C26.6525 36.0344 27.0096 35.957 27.3837 35.9356L31.3701 35.6147C31.0939 35.7368 30.1367 36.3163 29.9235 36.4828C29.2647 36.9945 28.8312 37.6662 28.5471 38.434C28.75 37.604 29.1288 36.8532 29.7561 36.2608C29.6236 36.3376 29.4912 36.4232 29.3679 36.5176C28.709 37.0293 28.2755 37.701 27.9915 38.4688C28.1944 37.6388 28.5732 36.888 29.2004 36.2956C29.0679 36.3724 28.9355 36.458 28.8122 36.5524C28.1449 37.0902 27.7114 37.7618 27.4292 38.5349ZM35.5976 43.0443C35.7058 43.2411 35.8246 43.4259 35.9557 43.6039C35.6577 43.3557 35.3878 43.0783 35.1494 42.7646C34.7054 42.1794 34.4029 41.5263 34.1838 40.8411C34.3219 41.5899 34.5612 42.3068 34.9565 42.9715C35.0626 43.1457 35.1721 43.3129 35.2958 43.4698C35.0017 43.2409 34.7303 42.9843 34.4922 42.6881C34.0325 42.1255 33.7195 41.4844 33.4952 40.8096C33.6421 41.5498 33.8954 42.2564 34.3119 42.9057C34.4142 43.0606 34.5198 43.2086 34.6343 43.3479C34.3675 43.1542 34.1199 42.9399 33.895 42.6892C33.389 42.1295 33.0455 41.4776 32.8066 40.7782C32.9643 41.5237 33.2373 42.2358 33.6856 42.8663C33.7785 42.9949 33.8749 43.1165 33.973 43.2347C33.6992 43.055 33.4482 42.8476 33.2162 42.602C32.7088 42.0632 32.3603 41.4305 32.1144 40.7449C32.2792 41.494 32.5701 42.2063 33.0468 42.825C33.125 42.929 33.2103 43.0278 33.2974 43.1231C33.0292 42.9591 32.7802 42.7657 32.5502 42.5342C32.0305 42.0109 31.6715 41.3902 31.4222 40.7116C31.5997 41.4714 31.9103 42.1892 32.4278 42.7979C32.4895 42.872 32.553 42.9426 32.6218 43.0115C32.3682 42.8634 32.1302 42.6929 31.9095 42.4876C31.3633 41.9815 30.9954 41.3607 30.7389 40.6785C30.9215 41.4191 31.2335 42.1159 31.7471 42.7054C31.8106 42.776 31.8777 42.8485 31.9429 42.9156C31.6912 42.7815 31.4552 42.6162 31.2346 42.4196C30.6833 41.9239 30.3103 41.3223 30.0467 40.6452C30.2346 41.3841 30.5586 42.048 31.0757 42.6305C31.1555 42.7223 31.2388 42.8071 31.3256 42.885C30.3263 42.244 29.6368 41.1164 29.5296 39.8288C29.3934 38.1673 30.2915 36.6446 31.6946 36.0796C33.1329 35.9391 34.5178 35.4646 35.6879 34.9263C35.3241 36.3039 35.1746 37.8187 35.3062 39.4173C35.4222 40.8046 35.7242 42.1244 36.1831 43.3275C36.0417 43.1704 35.9054 43.0028 35.7815 42.8285C35.3586 42.2279 35.0702 41.5645 34.8635 40.8725C34.9964 41.6316 35.2198 42.3623 35.5976 43.0443ZM36.6737 41.8485C36.3082 40.4581 36.1595 39.0285 36.2213 37.6086C36.2931 35.9079 36.7031 34.1765 37.5557 32.7091C38.3476 31.3457 39.6053 30.1365 41.2725 29.9327C41.4006 29.9186 41.5289 29.9133 41.6572 29.9079C40.9705 29.9986 40.3373 30.207 39.7656 30.5889C39.1004 31.0324 38.5572 31.6451 38.1307 32.3116C37.2396 33.7122 36.8053 35.3664 36.6614 37.0139C36.5434 38.3754 36.6308 39.7658 36.9048 41.115C37.2422 42.7598 37.8719 44.4032 38.8968 45.7759C39.847 47.0464 41.1756 48.1158 42.8108 48.264C42.9304 48.276 43.0517 48.2758 43.1765 48.2774C42.4391 48.3169 41.7385 48.2015 41.058 47.8926C40.2933 47.546 39.6309 47.0209 39.0653 46.4099C37.8831 45.1277 37.1092 43.4947 36.6737 41.8485ZM48.1072 43.7677C47.9294 44.3762 47.707 44.9755 47.4054 45.5354C47.1455 46.0208 46.8368 46.4602 46.4832 46.8815C47.13 46.052 47.59 45.1381 47.9061 44.1351C48.251 43.0382 48.4221 41.8763 48.4684 40.7215C48.5601 38.3508 48.1372 35.9054 47.1194 33.7178C46.6142 32.6345 45.9307 31.6659 45.0428 30.8465C45.8558 31.5462 46.5049 32.3678 47.0061 33.3062C47.5715 34.3676 47.9561 35.486 48.2271 36.6431C48.5057 37.83 48.6245 39.0584 48.604 40.2694C48.5848 41.4508 48.4427 42.6357 48.1072 43.7677Z"
                                          fill="current"
                                          className="White"
                                        />
                                        <path
                                          d="M42 37C42.5 38 42.8188 38.8333 43.1824 39.5L46.4545 40L47 38.5V36.5C46.8182 36 46.4545 34.9 46.4545 34.5C46.4545 34.1 45.8636 32.8333 45.5 32.5L44.5 33L41 34.5C41.0001 35 41.7352 36.4705 42 37Z"
                                          fill="current"
                                          className="DarkGray"
                                        />
                                        <path
                                          d="M47.8653 32.2753C48.1452 32.1636 48.4159 32.0344 48.6795 31.9017C49.4013 31.5426 50.0883 31.1273 50.7699 30.7049C50.5024 30.5845 50.2386 30.466 49.9676 30.3526C50.6221 29.9037 51.2654 29.4319 51.8491 28.9001C51.4913 29.0508 51.1446 29.2244 50.7997 29.4033C50.1985 29.7185 49.612 30.067 49.0309 30.4139C49.2894 30.5342 49.548 30.6544 49.8083 30.7712C49.7466 30.814 49.6866 30.8534 49.6248 30.8962C49.011 31.3177 48.4028 31.7638 47.8653 32.2753Z"
                                          fill="white"
                                        />
                                        <path
                                          d="M49.3979 35.3473C49.7078 35.3286 50.0137 35.2819 50.3196 35.2352C51.1164 35.1127 51.8997 34.9272 52.6811 34.7365C52.4624 34.5452 52.2455 34.3505 52.0215 34.1609C52.7899 33.9333 53.5526 33.6812 54.2802 33.3554C53.8904 33.3906 53.5026 33.4485 53.115 33.5151C52.4376 33.6321 51.7697 33.7841 51.1017 33.9362C51.3115 34.1274 51.5212 34.3185 51.7363 34.508C51.6635 34.528 51.5907 34.5481 51.518 34.5681C50.7923 34.7909 50.0722 35.0296 49.3979 35.3473Z"
                                          fill="white"
                                        />
                                        <path
                                          d="M52.9947 38.608C53.8026 38.6253 54.6172 38.62 55.4145 38.5324C55.0263 38.4472 54.6367 38.3829 54.2455 38.3307C53.5576 38.2347 52.8686 38.177 52.1796 38.1194C52.3188 38.362 52.4617 38.6064 52.6062 38.8474C52.2603 38.8395 51.9126 38.835 51.5686 38.8411C51.0803 38.8488 50.5867 38.867 50.1028 38.9289C50.407 39.0026 50.7163 39.0571 51.0254 39.103C51.8295 39.2267 52.6399 39.2929 53.4465 39.3485C53.2965 39.1005 53.1501 38.8543 52.9947 38.608Z"
                                          fill="white"
                                        />
                                        <path
                                          d="M53.2218 43.8661C53.1391 43.591 53.0511 43.3176 52.9631 43.0442C53.7471 43.2532 54.5433 43.4379 55.3471 43.5441C54.9897 43.3703 54.6255 43.219 54.2542 43.0729C53.6049 42.8186 52.9473 42.599 52.2843 42.3811C52.3616 42.6491 52.4388 42.9171 52.5213 43.1835C52.1848 43.0936 51.8465 43.0073 51.5084 42.9297C51.029 42.8206 50.5443 42.7219 50.0551 42.6685C50.3336 42.8117 50.6225 42.9341 50.9114 43.0564C51.6703 43.3698 52.4461 43.6223 53.2218 43.8661Z"
                                          fill="white"
                                        />
                                        <path
                                          d="M53.9089 48.0845C53.6055 47.8293 53.2864 47.5965 52.9619 47.3655C52.3942 46.9656 51.8037 46.5933 51.2168 46.2228C51.2229 46.4986 51.2325 46.7762 51.2439 47.0504C50.9382 46.8807 50.629 46.7179 50.3218 46.5604C49.8798 46.3401 49.4344 46.1267 48.9719 45.9568C49.2068 46.1605 49.4575 46.3504 49.7099 46.5369C50.3663 47.02 51.0575 47.4512 51.7558 47.8772C51.7407 47.5925 51.7292 47.3096 51.7105 47.0232C52.4207 47.4162 53.1503 47.7885 53.9089 48.0845Z"
                                          fill="white"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_588_3800">
                                          <rect
                                            width="31.4717"
                                            height="28.92"
                                            fill="white"
                                            transform="translate(32.9932 19.5) rotate(26.4965)"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                    <span>BOGO</span>
                                    <p>Coming Soon</p>
                                  </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12">
                                  <div
                                    className="Offer_Type"
                                    style={{
                                      pointerEvents: "none",
                                      opacity: "0.4"
                                    }}
                                  >
                                    <svg
                                      width="75"
                                      height="76"
                                      viewBox="0 0 75 76"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <circle
                                        cx="37.875"
                                        cy="37.875"
                                        r="25"
                                        fill="current"
                                        className="DarkGray"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M16.0126 7.74333C22.1359 3.19119 29.6972 0.5 37.875 0.5C46.0528 0.5 53.6141 3.19119 59.7374 7.74333C60.6238 8.40233 60.8082 9.65516 60.1492 10.5416C59.4902 11.4281 58.2374 11.6124 57.3509 10.9534C51.8904 6.89402 45.1599 4.5 37.875 4.5C30.5901 4.5 23.8596 6.89403 18.3991 10.9535C17.5126 11.6124 16.2598 11.4281 15.6008 10.5416C14.9418 9.65516 15.1262 8.40233 16.0126 7.74333ZM65.1013 15.6001C66.0009 14.9592 67.2497 15.1688 67.8907 16.0684C72.2863 22.2377 74.875 29.8164 74.875 38C74.875 46.1836 72.2863 53.7623 67.8907 59.9316C67.2497 60.8311 66.0009 61.0408 65.1013 60.3999C64.2017 59.7589 63.992 58.5101 64.633 57.6105C68.5593 52.0998 70.875 45.3284 70.875 38C70.875 30.6716 68.5593 23.9002 64.633 18.3895C63.992 17.4899 64.2017 16.2411 65.1013 15.6001ZM10.6487 15.6001C11.5483 16.2411 11.758 17.4899 11.117 18.3895C7.1907 23.9002 4.875 30.6716 4.875 38C4.875 45.3284 7.1907 52.0998 11.117 57.6105C11.758 58.5101 11.5483 59.7589 10.6487 60.3999C9.74912 61.0408 8.50027 60.8312 7.85932 59.9316C3.46375 53.7623 0.875 46.1836 0.875 38C0.875 29.8164 3.46375 22.2377 7.85932 16.0684C8.50027 15.1689 9.74912 14.9592 10.6487 15.6001ZM15.6008 65.4584C16.2598 64.5719 17.5126 64.3876 18.3991 65.0466C23.8596 69.106 30.5901 71.5 37.875 71.5C45.1599 71.5 51.8904 69.106 57.3509 65.0465C58.2374 64.3876 59.4902 64.5719 60.1492 65.4584C60.8082 66.3448 60.6238 67.5977 59.7374 68.2567C53.6141 72.8088 46.0528 75.5 37.875 75.5C29.6972 75.5 22.1359 72.8088 16.0126 68.2567C15.1262 67.5977 14.9418 66.3448 15.6008 65.4584Z"
                                        fill="current"
                                        className="LightGray"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M16.012 7.74333C22.1353 3.19119 29.6965 0.5 37.8743 0.5C46.0522 0.5 53.6134 3.19119 59.7367 7.74333C60.6231 8.40233 60.8075 9.65516 60.1485 10.5416C59.4895 11.4281 58.2367 11.6124 57.3502 10.9535C51.8897 6.89402 45.1592 4.5 37.8743 4.5C30.5894 4.5 23.859 6.89403 18.3984 10.9535C17.512 11.6125 16.2591 11.4281 15.6001 10.5416C14.9411 9.65516 15.1255 8.40233 16.012 7.74333Z"
                                        fill="current"
                                        className="LightGray"
                                      />
                                      <g clipPath="url(#clip0_588_3821)">
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M43.1947 29.5H43.3435C44.7578 26.9068 46.3209 25.6864 47.5118 25.3051C47.9584 25.2288 48.3306 25.2288 48.5539 25.3814C48.7772 25.6102 48.7772 25.9915 48.5539 26.4491C48.1073 27.2881 46.9908 28.4322 44.9066 29.7288C44.7578 29.4237 44.46 29.1949 44.1623 29.2712L43.1947 29.5ZM44.9811 30.1102C47.1396 28.8136 48.3306 27.5932 48.7027 26.678C49.0005 26.0678 49.0005 25.5339 48.7027 25.1525C48.405 24.9237 47.9584 24.8475 47.3629 25.0763C46.2464 25.3814 44.5345 26.678 42.9713 29.4237L37.24 30.1864C36.9422 30.339 36.7934 30.4153 36.7189 30.6441H36.6445L26.1493 44.678C25.8516 45.1356 25.926 45.5932 26.3726 45.9746L33.7416 51.8475C34.1882 52.1525 34.7836 52.0763 35.0814 51.6186L45.5765 37.661C45.5765 37.5847 45.5765 37.5847 45.651 37.5847C45.7254 37.5085 45.8743 37.2797 45.7254 37.0508L44.9811 30.1102ZM42.5247 31.178C42.3759 31.178 42.3759 31.2542 42.3759 31.2542C42.3759 31.3305 42.4503 31.3305 42.5992 31.3305C42.8969 31.2542 43.1947 31.0254 43.418 30.8729C43.4924 30.8729 43.4924 30.8729 43.4924 30.8729C43.939 31.178 43.939 31.7119 43.5668 32.1695C43.3435 32.4746 42.748 32.6271 42.4503 32.2458C42.0037 32.0169 42.0037 31.4068 42.227 31.1017C42.4503 30.7966 42.748 30.6441 43.0458 30.7966C42.8969 30.9491 42.7481 31.1017 42.5247 31.178ZM40.2173 34.9153L39.1752 36.2881L40.1429 37.0508L41.2594 35.3729L42.0037 35.8305L40.1429 38.3475L36.4956 35.678L38.3565 33.0085L38.9519 33.5424L37.6866 35.2203L38.5053 35.8305L39.5474 34.3051L40.2173 34.9153ZM38.0587 37.7373L37.0167 39.2627L37.9099 39.8729L39.1752 38.1949L39.7707 38.7288L37.9099 41.2458L34.2626 38.5L36.1235 35.983L36.8678 36.5169L35.6769 38.1949L36.4212 38.7288L37.4633 37.3559L38.0587 37.7373ZM34.1137 42.3136L34.5603 41.7034C34.6348 41.6271 34.6348 41.3983 34.6348 41.2458C34.6348 41.1695 34.6348 40.9407 34.4115 40.7881C34.337 40.7119 34.1137 40.7119 33.9649 40.7119C33.7416 40.7119 33.6671 40.7881 33.5183 41.0169L33.1461 41.5508L34.1137 42.3136ZM34.7092 42.7712L36.049 43.839L35.4536 44.678L31.8807 42.0085L32.8484 40.5593C33.1461 40.1017 33.5927 39.9491 33.8904 39.7966C34.337 39.7203 34.6348 39.7203 35.0069 40.0254C35.1558 40.1017 35.3047 40.3305 35.3047 40.5593C35.4536 40.7881 35.4536 40.9407 35.3047 41.1695C35.528 41.0932 35.8257 40.9407 36.049 40.9407C36.2723 40.9407 36.4956 41.0932 36.6445 41.1695L36.8678 41.3983C37.0167 41.4746 37.0911 41.4746 37.1655 41.6271C37.3888 41.7034 37.4633 41.7034 37.6121 41.6271V41.7034L37.0167 42.5424C36.8678 42.5424 36.7934 42.5424 36.7189 42.4661C36.4956 42.4661 36.4212 42.3898 36.2723 42.2373L36.049 42.0085C35.8257 41.9322 35.7513 41.9322 35.528 41.9322C35.4536 41.9322 35.2302 42.0085 35.0814 42.2373L34.7092 42.7712ZM33.5183 44.2966L32.4018 45.822L33.8904 46.8898L33.295 47.7288L29.7222 44.983L31.583 42.3136L32.1785 42.8475L30.9131 44.5254L31.7319 45.1356L32.8484 43.6102L33.5183 44.2966Z"
                                          fill="current"
                                          className="White"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_588_3821">
                                          <rect
                                            width="23"
                                            height="27"
                                            fill="current"
                                            transform="translate(26 25)"
                                            className="White"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                    <span>Cross Sell</span>
                                    <p>Coming Soon</p>
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-12 mt-28">
                                  <Form.Group
                                    controlId="reward_amount"
                                    className="form-group"
                                  >
                                    <Form.Label>Offer Value</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="E.g. 1.00"
                                      name="reward_amount"
                                      onChange={(e) => this.changeHandler(e)}
                                      defaultValue={
                                        this.state.couponsDetails
                                          ? this.state.couponsDetails
                                              .reward_amount
                                          : ""
                                      }
                                      step=".01"
                                    />
                                  </Form.Group>
                                </div>

                                <div className="col-12 mt-28">
                                  <Form.Group
                                    controlId="title"
                                    className="form-group"
                                  >
                                    <Form.Label>Title</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Title"
                                      name="title"
                                      defaultValue={
                                        this.state.couponsDetails
                                          ? this.state.couponsDetails.coupon_title.replace(
                                              /\\\\'/g,
                                              "'"
                                            )
                                          : ""
                                      }
                                      onChange={(e) => this.changeHandler(e)}
                                    />
                                  </Form.Group>
                                </div>

                                <div className="col-12 mt-28">
                                  <Form.Group className="form-group">
                                    <Form.Label>Description</Form.Label>
                                    <Form.Control
                                      placeholder="Description"
                                      as="textarea"
                                      rows={1}
                                      name="description"
                                      id="description"
                                      defaultValue={
                                        this.state.couponsDetails
                                          ? this.state.couponsDetails.coupon_description.replace(
                                              /\\'/g,
                                              "'"
                                            )
                                          : ""
                                      }
                                      onChange={(e) => this.changeHandler(e)}
                                    />
                                  </Form.Group>
                                </div>

                                <div className="col-md-4 col-12 mt-28">
                                  <Form.Group
                                    className="form-group"
                                    controlId="exampleForm.ControlInput1"
                                  >
                                    <Form.Label>Start Date</Form.Label>

                                    <Form.Control
                                      type="date"
                                      name="start_date"
                                      min={
                                        new Date().toISOString().split("T")[0]
                                      }
                                      onKeyDown={(e) => e.preventDefault()}
                                      onChange={(e) => this.setStartDate(e)}
                                      defaultValue={
                                        this.state.couponsDetails
                                          ? CalenderDateFormatter(
                                              new Date(
                                                this.state.couponsDetails.coupon_start_date
                                              )
                                            )
                                          : ""
                                      }
                                      disabled={true}
                                    />
                                  </Form.Group>
                                </div>

                                <div className="col-md-4 col-12 mt-28">
                                  <Form.Group
                                    className=" form-group"
                                    controlId="exampleForm.ControlInput2"
                                  >
                                    <Form.Label>End Date</Form.Label>

                                    <Form.Control
                                      type="date"
                                      name="end_date"
                                      min={
                                        new Date().toISOString().split("T")[0]
                                      }
                                      onKeyDown={(e) => e.preventDefault()}
                                      onChange={(e) => this.setEndDate(e)}
                                      defaultValue={
                                        this.state.couponsDetails
                                          ? CalenderDateFormatter(
                                              new Date(
                                                this.state.couponsDetails.coupon_end_date
                                              )
                                            )
                                          : ""
                                      }
                                      disabled={true}
                                    />
                                  </Form.Group>
                                </div>

                                <div className="col-md-4 col-12 mt-28">
                                  <Form.Group
                                    className=" form-group"
                                    controlId="exampleForm.ControlInput2"
                                  >
                                    <Form.Label>Shutoff Date</Form.Label>

                                    <Form.Control
                                      type="date"
                                      name="shutoff_date"
                                      min={
                                        new Date().toISOString().split("T")[0]
                                      }
                                      onKeyDown={(e) => e.preventDefault()}
                                      onChange={(e) => this.setShutoffDate(e)}
                                      defaultValue={
                                        this.state.couponsDetails
                                          ? CalenderDateFormatter(
                                              new Date(
                                                this.state.couponsDetails.coupon_shutoff_date
                                              )
                                            )
                                          : ""
                                      }
                                      disabled={true}
                                    />
                                  </Form.Group>
                                </div>

                                <div className="col-12 mt-28">
                                  <Form.Group className="form-group">
                                    <Form.Label>
                                      Min Purchase Quantity
                                    </Form.Label>
                                    <Form.Control
                                      placeholder="ENter qty here. Max qty allowed is 10"
                                      type="text"
                                      name="min_purchase_amount"
                                      id="min_purchase_amount"
                                      defaultValue={
                                        this.state.couponsDetails
                                          ? this.state.couponsDetails
                                              .min_quantity
                                          : ""
                                      }
                                      onChange={(e) => this.changeHandler(e)}
                                    />
                                  </Form.Group>
                                </div>

                                <div className="col-12 mt-28">
                                  <Form.Group
                                    controlId="Descripation"
                                    className="form-group"
                                  >
                                    <Form.Label>
                                      Purchase Requirement Description
                                    </Form.Label>
                                    <Form.Control
                                      placeholder="Purchase Requirement Description"
                                      as="textarea"
                                      rows={1}
                                      defaultValue={
                                        this.state.couponsDetails
                                          ? this.state.couponsDetails
                                              .addtional_details
                                          : ""
                                      }
                                      name="addtional_details"
                                      onChange={(e) => this.changeHandler(e)}
                                    />
                                  </Form.Group>
                                </div>

                                <div className="col-12 mt-28">
                                  <Form.Group
                                    controlId="Descripation"
                                    className="form-group"
                                  >
                                    <Form.Label>
                                      Coupon Legal Disclaimer
                                    </Form.Label>
                                    <Form.Control
                                      placeholder="Coupon Legal Copy"
                                      as="textarea"
                                      rows={4}
                                      defaultValue={
                                        this.state.couponsDetails
                                          ? this.state.couponsDetails.disclaimer
                                          : ""
                                      }
                                      name="disclaimer"
                                      onChange={(e) => this.changeHandler(e)}
                                    />
                                  </Form.Group>
                                </div>

                                <div className="col-12 mt-28">
                                  <Form.Group
                                    controlId="Descripation"
                                    className="form-group col-md-7"
                                  >
                                    <Form.Label>
                                      Coupon Limit{" "}
                                      <span
                                        style={{
                                          color: "red",
                                          paddingLeft: "15px",
                                          fontSize: "14px"
                                        }}
                                      ></span>
                                    </Form.Label>
                                    <br />
                                    <br />
                                    <select
                                      name="coupon_limit"
                                      className="form-group col-md-7"
                                      onChange={(e) =>
                                        this.props.changeHandler(e)
                                      }
                                      style={{
                                        borderColor: "#c4c4c4",
                                        padding: "10px"
                                      }}
                                      value={
                                        this.state.couponsDetails
                                          ? this.state.couponsDetails
                                              .coupon_condition
                                              .per_transaction_limit
                                          : ""
                                      }
                                      disabled
                                    >
                                      {Array.from(Array(15), (e, i) => {
                                        return (
                                          <option value={i + 1}>
                                            {" "}
                                            {i + 1}
                                          </option>
                                        );
                                      })}
                                    </select>
                                  </Form.Group>
                                </div>
                              </div>

                              <div className="row ">
                                <div className="col-lg-4 col-md-6 col-12 mt-28">
                                  <Form.Group
                                    controlId="Description"
                                    className="form-group"
                                  >
                                    <Form.Label>Coupon Image</Form.Label>
                                    <p>
                                      File must be 250px * 250px, 150dpi png or
                                      jpg
                                    </p>

                                    <div className="File_Upload position-relative ml-7">
                                      <img
                                        src={FileIcon}
                                        className="img-fluid"
                                        alt="File Icon"
                                      />
                                      <p>
                                        <b>Drag & Drop Your</b> files here or{" "}
                                        <b>
                                          <span>browse</span>
                                        </b>{" "}
                                        your computer
                                      </p>
                                      <input
                                        id="file-upload"
                                        type="file"
                                        name="fileUpload"
                                        onChange={(e) => this.onFileChange(e)}
                                        defaultValue={
                                          this.state.couponsDetails
                                            ? this.state.couponsDetails
                                                .min_purchase_amount
                                            : ""
                                        }
                                        onClick={(event) => {
                                          event.target.value = null;
                                        }}
                                      />
                                    </div>
                                  </Form.Group>
                                </div>

                                <div className="col-lg-4 col-md-6 col-12 mt-28"></div>
                              </div>

                              <div className="row"></div>

                              <div className="row mt-20">
                                <div className="col-12 d-flex justify-content-end">
                                  <div className="TableButton">
                                    <button
                                      type="button"
                                      className="mr-10 btn btn-primary"
                                      onClick={(e) => {
                                        this.changePrevTab(e, 1);
                                      }}
                                    >
                                      <i
                                        className="fas fa-arrow-left mr-10"
                                        aria-hidden="true"
                                      ></i>{" "}
                                      Prev
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={(e) => {
                                        this.changeSecondTab(e, 3);
                                      }}
                                    >
                                      Save & Next{" "}
                                      <i
                                        className="fas fa-arrow-right ml-10"
                                        aria-hidden="true"
                                      ></i>{" "}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-xxl-3 col-xl-4 col-12">
                          <CouponSummary
                            upcArrlength={
                              this.state.UpcList
                                ? this.state.UpcList.length
                                : ""
                            }
                            reward_amount={
                              this.state.formControls.reward_amount
                            }
                          />
                          {this.state.formControls.title &&
                            this.state.formControls.description &&
                            this.state.selectedFile && (
                              <CouponPreview
                                title={
                                  this.state.formControls.title
                                    ? this.state.formControls.title
                                    : ""
                                }
                                description={
                                  this.state.formControls.description
                                    ? this.state.formControls.description
                                    : ""
                                }
                                selectedFile={
                                  this.state.selectedFile
                                    ? this.state.selectedFile
                                    : ""
                                }
                              />
                            )}
                        </div>
                      </div>
                    </div>

                    <div
                      className="tab-pane fade"
                      id="nav-step-3"
                      role="tabpanel"
                      aria-labelledby="nav-step-3-tab"
                    >
                      <div className="row  g-3 justify-content-center">
                        <div className="col-12">
                          <div className="Preview_Card Common_Block">
                            <div className="Common_Block_Body">
                              <h5>
                                <span>
                                  Your offers update will be sent to retailers
                                </span>{" "}
                                <b>within</b>{" "}
                              </h5>
                              <h4>24 hours</h4>
                              <div className="Preview_Outer_Block">
                                <ul className="Preview_Card_Row">
                                  <li
                                    className=" text-center Coupons_Image"
                                    style={{ margin: "0 auto", width: "50%" }}
                                  >
                                    <div className="Coupons_Outer_Block">
                                      <div className="Coupons_Card">
                                        <img
                                          src={
                                            this.state.selectedFile
                                              ? this.state.selectedFile
                                              : Blockbg
                                          }
                                          className="img-fluid"
                                          alt="Coupon"
                                        />
                                        <h2 className="Price">
                                          {this.state.formControls.title}
                                          <span></span>
                                        </h2>
                                        <p>
                                          {this.state.formControls.description}
                                        </p>
                                      </div>
                                    </div>
                                  </li>
                                </ul>

                                <div className="row  ">
                                  <div className="col-lg-6 col-12 mt-45">
                                    <div className="date d-flex align-items-center ">
                                      <Form.Group
                                        className=""
                                        controlId="exampleForm.ControlInput1"
                                      >
                                        <img
                                          src={CalenderSvgImage}
                                          className="img-fluid"
                                          alt="Calender"
                                        />

                                        <Form.Label>
                                          &nbsp;Start: &nbsp;
                                        </Form.Label>

                                        <span className="fw-bold">
                                          {this.state.couponsDetails
                                            ? DateFormatter(
                                                new Date(
                                                  this.state.couponsDetails.coupon_start_date
                                                )
                                              )
                                            : ""}
                                        </span>
                                      </Form.Group>

                                      <Form.Group
                                        className="ml-12"
                                        controlId="exampleForm.ControlInput2"
                                      >
                                        <img
                                          src={CalenderSvgRedImage}
                                          className="img-fluid"
                                          alt="Calender"
                                        />

                                        <Form.Label>
                                          &nbsp; End: &nbsp;
                                        </Form.Label>

                                        <span className="fw-bold">
                                          {" "}
                                          {this.state.couponsDetails
                                            ? DateFormatter(
                                                new Date(
                                                  this.state.couponsDetails.coupon_end_date
                                                )
                                              )
                                            : ""}
                                        </span>
                                      </Form.Group>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 col-12 mt-45">
                                    <Link to="/wholesalerlist">
                                      <Button
                                        variant=""
                                        type="button "
                                        className=" Btn_blue mt-20 w-50 ms-auto"
                                      >
                                        Back To Coupon List
                                        <img
                                          src={Arrowsvg}
                                          className="img-fluid float-end"
                                          alt="Arrow"
                                        />
                                      </Button>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
        <FooterStrict />
      </>
    );
  }
}

export default EditCoupon;
